import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/nav/logo.svg'
import _imports_1 from '@/assets/menu-sp.svg'
import _imports_2 from '@/assets/close-sp.svg'


const _withScopeId = n => (_pushScopeId("data-v-88928d66"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nav" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo-icon",
  src: _imports_0,
  alt: "logo"
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "languages" }
const _hoisted_5 = { class: "languages-lang" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stick" }, null, -1))
const _hoisted_7 = { class: "list-item" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "hambugers" }
const _hoisted_10 = {
  key: 1,
  src: _imports_2,
  class: "close"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", {
      class: "nav__logo",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToHome && _ctx.goToHome(...args)))
    }, _hoisted_3),
    _createElementVNode("div", {
      class: _normalizeClass(["nav__items", _ctx.isShowMenu && 'show'])
    }, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("a", {
            class: _normalizeClass(['lang', _ctx.activeLang === 'ja-JP' && 'activeLang']),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeLangs('ja-JP')))
          }, "JA", 2),
          _hoisted_6,
          _createElementVNode("a", {
            class: _normalizeClass(['lang', _ctx.activeLang === 'en-US' && 'activeLang']),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeLangs('en-US')))
          }, "EN", 2)
        ]),
        _createVNode(_component_Button, {
          title: _ctx.t('top.contact'),
          onClick: _ctx.goToContact,
          class: _normalizeClass([_ctx.activeLang === 'ja-JP' && 'ja'])
        }, null, 8, ["title", "onClick", "class"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nav, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.name,
            class: _normalizeClass(['item', _ctx.activeLang === 'ja-JP' && 'active-lang nav-item']),
            onClick: ($event: any) => (_ctx.gotoTopTag(item.name))
          }, _toDisplayString(_ctx.$t(item.text)), 11, _hoisted_8))
        }), 128))
      ])
    ], 2),
    _createElementVNode("div", {
      class: "nav__hambugers",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isShowMenu = !_ctx.isShowMenu))
    }, [
      _createElementVNode("div", _hoisted_9, [
        (!_ctx.isShowMenu)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: _normalizeClass(["menu", _ctx.isShowMenu && 'show']),
              src: _imports_1
            }, null, 2))
          : (_openBlock(), _createElementBlock("img", _hoisted_10))
      ])
    ])
  ]))
}